import { MapPin, Phone } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { navigation } from "../../data/navigation";
import { siteConfig } from "../../data/siteConfig";
import { safeExternalUrl } from "../../lib/whatsapp";
import { BrandLogo } from "../shared/BrandLogo";

export function Footer() {
  const socialLinks = [
    { label: "Instagram", url: safeExternalUrl(siteConfig.instagramUrl) },
    { label: "Facebook", url: safeExternalUrl(siteConfig.facebookUrl) },
  ].filter((link): link is { label: string; url: string } => Boolean(link.url));

  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div className="site-footer__brand">
          <BrandLogo inverse />
          <p>Sabores preparados com cuidado, proximidade e aquele toque familiar.</p>
        </div>
        <div>
          <h2>Explorar</h2>
          <nav aria-label="Navegação do rodapé">
            {navigation.map((item) => <Link key={item.to} to={item.to}>{item.label}</Link>)}
            <Link to="/politica-de-privacidade">Política de privacidade</Link>
          </nav>
        </div>
        <div>
          <h2>Contactos</h2>
          <a href={`tel:+${siteConfig.phoneRaw}`}><Phone size={17} aria-hidden="true" />{siteConfig.phoneDisplay}</a>
          <p><MapPin size={17} aria-hidden="true" />{siteConfig.address}</p>
          {socialLinks.map((link) => <a key={link.label} href={link.url} target="_blank" rel="noopener noreferrer">{link.label}</a>)}
        </div>
      </div>
      <div className="container site-footer__bottom">
        <p>© {new Date().getFullYear()} Pastelaria Casagrande. Todos os direitos reservados.</p>
        <p className="asset-note">Logótipo oficial por adicionar</p>
      </div>
    </footer>
  );
}
